export interface VoiceDiagnostics {
  backend: 'sfu';
  state: RTCPeerConnectionState | 'connecting' | 'disconnected';
  route: 'direct' | 'turn' | 'unknown';
  rttMs: number | null;
  jitterMs: number | null;
  packetsLost: number;
}

type StatsLike = { forEach(callback: (value: Record<string, unknown>) => void): void };

export function summarizeRtcStats(
  reports: StatsLike[],
): Omit<VoiceDiagnostics, 'backend' | 'state'> {
  let rttMs: number | null = null;
  let jitterMs: number | null = null;
  let packetsLost = 0;
  let route: VoiceDiagnostics['route'] = 'unknown';
  const candidates = new Map<string, Record<string, unknown>>();
  const pairs: Record<string, unknown>[] = [];

  for (const report of reports) {
    report.forEach((stat) => {
      if (stat.type === 'local-candidate' || stat.type === 'remote-candidate') {
        if (typeof stat.id === 'string') candidates.set(stat.id, stat);
      } else if (stat.type === 'candidate-pair') {
        pairs.push(stat);
      } else if (stat.type === 'inbound-rtp' && stat.kind === 'audio') {
        if (typeof stat.jitter === 'number') jitterMs = Math.max(jitterMs ?? 0, stat.jitter * 1000);
        if (typeof stat.packetsLost === 'number') packetsLost += Math.max(0, stat.packetsLost);
      }
    });
  }
  const selected = pairs.find(
    (pair) => pair.selected === true || (pair.nominated === true && pair.state === 'succeeded'),
  );
  if (selected) {
    if (typeof selected.currentRoundTripTime === 'number') {
      rttMs = selected.currentRoundTripTime * 1000;
    }
    const local = typeof selected.localCandidateId === 'string'
      ? candidates.get(selected.localCandidateId)
      : undefined;
    const remote = typeof selected.remoteCandidateId === 'string'
      ? candidates.get(selected.remoteCandidateId)
      : undefined;
    route = local?.candidateType === 'relay' || remote?.candidateType === 'relay' ? 'turn' : 'direct';
  }
  return { route, rttMs, jitterMs, packetsLost };
}
